'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-to-primitive/es6.js
// module id = 460
// module chunks = 0